import React from "react";
import "./style.css";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Container, Row, Col } from "react-bootstrap";
import { databooks, meta } from "../../content_option";

export const Bookshelf = () => {
  return (
    <HelmetProvider>
      <Container className="About-header">
        <Helmet>
          <meta charSet="utf-8" />
          <title> Bookshelf | {meta.title} </title>
          <meta name="description" content={meta.description} />
        </Helmet>
        <Row className="mb-5 mt-3 pt-md-3">
          <Col lg="8">
            <h1 className="display-4 mb-4"> Bookshelf </h1>
            <hr className="t_border my-4 ml-0 text-left" />
          </Col>
        </Row>
        <Row className="mb-4">
          <Col lg="12">
            <p className="lead">
              Here's a curated collection of books that have profoundly influenced my thinking about technology, 
              finance, art, history and life in general. Each of these works has contributed valuable insights to my 
              professional journey, and I'm excited to share them with you.
            </p>
          </Col>
        </Row>
        <div className="mb-5 books_items_ho">
          {databooks.map((book, i) => {
            return (
              <div key={i} className="book_item">
                <img src={book.cover} alt={book.title} />
                <div className="content">
                  <h3>{book.title}</h3>
                  <p className="author">by {book.author}</p>
                  <p className="description">{book.description}</p>
                  {book.link && (
                    <a href={book.link} target="_blank" rel="noopener noreferrer">
                      Read More
                    </a>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </Container>
    </HelmetProvider>
  );
};